import { render, staticRenderFns } from "./Facecast.vue?vue&type=template&id=e4ebe8c8&scoped=true"
import script from "./Facecast.vue?vue&type=script&lang=js"
export * from "./Facecast.vue?vue&type=script&lang=js"
import style0 from "./Facecast.vue?vue&type=style&index=0&id=e4ebe8c8&prod&lang=scss&scoped=true"
import style1 from "./Facecast.vue?vue&type=style&index=1&id=e4ebe8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ebe8c8",
  null
  
)

export default component.exports